import { render, staticRenderFns } from "./SidebarEntry.vue?vue&type=template&id=53d5ee12&scoped=true&"
import script from "./SidebarEntry.vue?vue&type=script&lang=js&"
export * from "./SidebarEntry.vue?vue&type=script&lang=js&"
import style0 from "./SidebarEntry.vue?vue&type=style&index=0&id=53d5ee12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d5ee12",
  null
  
)

export default component.exports